import React, { Component } from 'react';
// import { Container, Content, button, Text, Form, Item, input, label } from 'native-base';
import UserContext from '../../utils/userContext';

import axios from 'axios'

import {
    Redirect
} from 'react-router-dom'


export default class Logout extends Component {
    static contextType = UserContext
    constructor(props) {
        super(props);
        this.state = {

        }
        this.logout = this.logout.bind(this)
    }

    logout() {
        let self = this
        axios({
            method: 'post',
            url: `https://www.borntodev.com/wp-json/devblog/v1/logout`,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
            .then(function (response) {
                let data = {
                    "loggedIn": false,
                    "token": "",
                    "id": "",
                    "email": "",
                    "nicename": "",
                    "firstName": "",
                    "lastName": "",
                    "displayName": "Anonymous",
                    "profileImage": "https://images.unsplash.com/photo-1550165703-d2ed566a8c4f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=634&q=80"
                };

                localStorage.removeItem('btd-bdt')

                self.context.setUserData(data);
                self.props.goHome()

            }).catch(function (response) {

            });


    }

    render() {
        return (
            <div className="nav-bar-logout" onClick={this.logout}>
                ออกจากระบบ
            </div>
        )
    }
}
